// extracted by mini-css-extract-plugin
module.exports = {"container":"Twitch_container__94fk_","hasDesktopAdhesion":"Twitch_hasDesktopAdhesion__kDAv6","close":"Twitch_close__87s0a"};